import { ArrowRight, MapPin } from "lucide-react";
import { AMANDA_PHOTO, HERO } from "../../data/mock";

export default function Hero() {
  return (
    <section
      id="top"
      data-testid="hero-section"
      className="relative pt-32 pb-20 md:pt-40 md:pb-28 lg:pt-44 lg:pb-32 bg-cream overflow-hidden"
    >
      {/* Decorative mustard bar */}
      <div className="absolute top-0 left-0 right-0 h-1 bg-mustard" aria-hidden="true" />

      <div className="max-w-7xl mx-auto px-6 md:px-10 lg:px-14 grid lg:grid-cols-12 gap-12 lg:gap-16 items-center">
        {/* Text column */}
        <div className="lg:col-span-7 order-2 lg:order-1">
          <span className="eyebrow" data-testid="hero-eyebrow">{HERO.eyebrow}</span>

          <h1
            data-testid="hero-name"
            className="font-display text-5xl sm:text-6xl lg:text-[88px] leading-[1.02] tracking-tight text-navy mt-6"
          >
            {HERO.name.split(" ")[0]}
            <br />
            <span className="italic mustard-underline">{HERO.name.split(" ")[1]}</span>
          </h1>

          <p
            data-testid="hero-tagline"
            className="mt-7 text-xl md:text-2xl text-navy/85 max-w-2xl font-display italic leading-snug"
          >
            {HERO.tagline}
          </p>

          <p
            data-testid="hero-intro"
            className="mt-5 text-lg text-ink-muted max-w-xl leading-relaxed"
          >
            {HERO.intro}
          </p>

          <div className="mt-9 flex flex-wrap gap-4">
            <a href="#work" data-testid="hero-cta-primary" className="btn-primary">
              See selected work <ArrowRight size={18} />
            </a>
            <a href="#contact" data-testid="hero-cta-secondary" className="btn-outline">
              Get in touch
            </a>
          </div>

          <div className="mt-10 flex items-center gap-2.5 text-sm text-ink-muted">
            <MapPin size={16} className="text-terracotta" />
            <span data-testid="hero-location">Twin Waters, Sunshine Coast · Available worldwide</span>
          </div>
        </div>

        {/* Image column */}
        <div className="lg:col-span-5 order-1 lg:order-2">
          <div className="relative">
            {/* Mustard offset frame */}
            <div
              className="absolute -top-5 -right-5 md:-top-7 md:-right-7 w-full h-full border-[1.5px] border-mustard"
              aria-hidden="true"
            />
            <div className="image-frame relative overflow-hidden">
              <img
                src={AMANDA_PHOTO}
                alt="Portrait of Amanda Abbott"
                data-testid="hero-portrait"
                className="w-full h-[480px] md:h-[600px] lg:h-[680px] object-cover object-center"
                loading="eager"
              />
            </div>
            {/* Terracotta corner caption */}
            <div className="absolute -bottom-4 -left-4 md:-bottom-5 md:-left-5 bg-terracotta text-cream px-5 py-3 font-display italic text-lg">
              Est. on the Sunshine Coast since 2019
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
